
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertIndicatorResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"indicator_response_insert_input"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_indicator_response"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responses"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"indicator_response_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"checklists"},{"kind":"EnumValue","value":"compliance"},{"kind":"EnumValue","value":"non_compliance_statement"},{"kind":"EnumValue","value":"nc_status_created_by_id"},{"kind":"EnumValue","value":"non_compliance_type"},{"kind":"EnumValue","value":"refer_to_ca"},{"kind":"EnumValue","value":"non_conformity_status"},{"kind":"EnumValue","value":"observation"},{"kind":"EnumValue","value":"risk_impact"},{"kind":"EnumValue","value":"risk_likelihood"},{"kind":"EnumValue","value":"risk_rating"},{"kind":"EnumValue","value":"risk_type"},{"kind":"EnumValue","value":"is_marked_complete"},{"kind":"EnumValue","value":"further_action_required"},{"kind":"EnumValue","value":"reviewed"},{"kind":"EnumValue","value":"date_closed"}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returning"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checklists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"indicator_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"non_compliance_statement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nc_status_created_by_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"non_compliance_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refer_to_ca"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"non_conformity_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_impact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_likelihood"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_marked_complete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"further_action_required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviewed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_closed"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1330}};
    doc.loc.source = {"body":"\nmutation upsertIndicatorResponses($responses: [indicator_response_insert_input!]!) {\n    insert_indicator_response(\n        objects: $responses,\n        on_conflict: {\n            constraint: indicator_response_pkey,\n            update_columns: [\n                checklists\n                compliance\n                non_compliance_statement\n                nc_status_created_by_id\n                non_compliance_type\n                refer_to_ca\n                non_conformity_status\n                observation\n                risk_impact\n                risk_likelihood\n                risk_rating\n                risk_type\n                is_marked_complete\n                further_action_required\n                reviewed\n                date_closed\n            ]\n        }\n    ) {\n        affected_rows\n        returning {\n            checklists\n            compliance\n            id\n            indicator_id\n            non_compliance_statement\n            nc_status_created_by_id\n            non_compliance_type\n            refer_to_ca\n            non_conformity_status\n            observation\n            risk_impact\n            risk_likelihood\n            risk_rating\n            risk_type\n            is_marked_complete\n            further_action_required\n            reviewed\n            date_closed\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["upsertIndicatorResponses"] = oneQuery(doc, "upsertIndicatorResponses");
        
